import { state, actions, mutations } from '../base/index'

const cities = {
  namespaced: true,
  state: Object.assign({}, state),
  mutations: Object.assign({}, mutations),
  actions: Object.assign({}, actions),
  getters: {
    selectList: (state) => {
      let result = []
      let activeList = state.list.filter(item => item.active)
      activeList.forEach(item => {
        result.push({
          text: item.name,
          value: item._id,
          meta: item.provinceId
        })
      })
      return result
    }
  }
}

cities.state.type = 'towns'
cities.state.type2 = 'town'
cities.state.url = 'towns/'

export default cities
